<template>
  <!-- 带个人中心,商城首页,消息的头部 -->
  <div class="headerSecond">
    <div class="bottom-head">
      <el-row class="contain">
        <el-col :span="7">
          <div class="head-logo">
            <img src="../../assets/img/logo6-2.png" alt />
          </div>
        </el-col>
        <el-col :span="17" class="jz">
          <div>
            <el-menu
              :default-active="activeIndex"
              class="el-menu-black"
              id="topNav"
              mode="horizontal"
              @select="handleSelect"
              background-color="#f64420"
              text-color="#fff"
              :router="true"
            >
              <!-- <el-menu-item index="personalInformation" v-if="!isYS">个人中心</el-menu-item>-->
              <el-menu-item index="PersonalCenter" @click="refresh()">个人中心</el-menu-item>
              <el-menu-item index="ShopIndex" >
                <a href="#">药城首页</a>
              </el-menu-item>
              <el-menu-item index="/message">
                <el-badge
                  :value="$store.state.messageTotal == 0?'':$store.state.messageTotal"
                  class="item messageClass"
                  type="warning"
                >
                  <span size="small">消息</span>
                </el-badge>
                <!-- <a href="#">
                                    <span slot="label">
                                        消息
                                        <el-badge
                                            style="margin-left: 10px;"
                                            :value="messageCounts"
                                        />
                                    </span>
                </a>-->
              </el-menu-item>
              <!-- <el-menu-item index @click="changRole" v-if="isYS">
                <a href="#">切换角色</a>
              </el-menu-item> -->
              <!-- <el-menu-item index v-if="isYS">
                                <a href="http://www.cty001.com/#/personalFiles">保存到桌面</a>
              </el-menu-item>-->
            </el-menu>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerSecond",
  data() {
    return {
      activeIndex: "PersonalCenter",
      one: true,
      total: ""
    };
  },
  methods: {
    handleSelect(index) {
      this.activeIndex = index;
    },
    //切换角色
    changRole() {
      let that = this;
      if (sessionStorage.getItem("YS") == "false") {
        //当前不是医师
        sessionStorage.setItem("YS", true);
        this.$router.push({
          path: "/personalFiles"
        });
      } else {
        sessionStorage.setItem("YS", false);
        this.$router.push({
          path: "/personalInformation"
        });
      }
      // // 刷新兄弟组件
      let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
      this.$router.push(NewPage);
      this.$router.go(-1);
    },
    //保存到桌面
    saveZhuo() {
      var shortcutUrl = "http://localhost:8080/jd/";
      var url =
        "http://localhost:8080/jd/computer/CreateShortcut.do?shortcutUrl=" +
        shortcutUrl;
      $.get(
        url,
        function(data) {
          if (data != null) {
            alert("添加桌面快捷方式成功！");
          } else {
            alert("添加桌面快捷方式失败！");
          }
        },
        "text"
      );
    },
    //得到各个分类数量
    getOwnCount() {
      let that = this;
      let url = "wlMessage/get";
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      let params = {
        spCty: userInfo.id
      };
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.counts.pt = res.data.pt.unRead == 0 ? "" : res.data.pt.unRead;
            that.counts.wl = res.data.wl.unRead == 0 ? "" : res.data.wl.unRead;
            that.counts.ys = res.data.ys.unRead == 0 ? "" : res.data.ys.unRead;
            that.counts.hz = res.data.hz.unRead == 0 ? "" : res.data.hz.unRead;
            if (!that.isYS) {
              that.total =
                res.data.pt.unRead + res.data.wl.unRead + res.data.ys.unRead;
            } else {
              that.total = res.data.hz.unRead;
            }
            that.$store.commit("computerMessageTotal", that.total);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    refresh() {
      //个人中心刷新
      this.i1 = sessionStorage.setItem("leftIndex1", 100);
      this.i2 = sessionStorage.setItem("leftIndex2", 100);
      this.i3 = sessionStorage.setItem("leftIndex3", 100);
      // // 刷新兄弟组件
      let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
      this.$router.push(NewPage);
      this.$router.go(-1);
    }
  },
  created() {
    if (this.$store.state.userInfo) {
      this.userInfo = this.$store.state.userInfo;
      this.isYS = this.$store.state.userInfo.userType==2?true:false;
      this.getOwnCount();
    }
    // console.log(this.$store.state.userInfo)
   
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .el-menu.el-menu--horizontal {
    border-bottom: none;
} */
.bottom-head .is-active {
  color: #fff !important;
  border-bottom: 2px solid #fff;
}
.bottom-head {
  background-color: #f64420;
  height: 94px;
  line-height: 94px;
}
.returnButton {
  border-radius: 16px;
  border: solid 1px #ffffff;
  background-color: #f64420;
  color: #fff;
}
.head-logo img {
  text-align: center;
  vertical-align: middle;
}
/* .el-menu--horizontal > .el-menu-item {
    height: 94px;
    line-height: 94px;
} */
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.jz {
  padding: 15px 0px;
}
</style>
<style>
.messageClass .el-badge__content {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/headerSecond1.vue